import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { URLS } from '@wix/da-url';
import s from './PayPalAccountBlock.scss';

export interface Props {
  paypalEmail?: string;
  className?: string;
}

const PayPalAccountBlock: FC<Props> = ({ paypalEmail = 'example@gmail.com', className }) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <div className={s['account-info']}>
        <span className={s['account-label']}>
          {t('studio.earnings.withdrawToPayPal.confirmation.accountLabel')}
        </span>
        <span className={s['account-email']}>{paypalEmail}</span>
      </div>

      <div className={s['change-account']}>
        {t('studio.earnings.withdrawToPayPal.confirmation.changePrompt')}{' '}
        <a href={URLS.SUPPORT} className="text-link-level-2-secondary">
          {t('studio.earnings.withdrawToPayPal.confirmation.contactSupport')}
        </a>
        .
      </div>
    </div>
  );
};

PayPalAccountBlock.displayName = 'PayPalAccountBlock';

export default PayPalAccountBlock;
